import {useState} from 'react';
import {Button} from '../../ui';
import './team-choice.css';

function ChoiceCrest({src}) {
  const [failedSrc,setFailedSrc] = useState(null);
  return <span className="fc-team-choice__crest" aria-hidden="true">
    {src && failedSrc !== src ? <img src={src} alt="" onError={()=>setFailedSrc(src)}/> :
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 3L4 6.5V12.5C4 17.5 12 21 12 21C12 21 20 17.5 20 12.5V6.5L12 3Z" fill="var(--fc-disabled-surface)" stroke="var(--fc-control-border)" strokeWidth="2"/></svg>}
  </span>;
}

/** Read-only presentation of a choice; the caller owns all eligibility and actions. */
export default function TeamChoice({name, crest, side, ...buttonProps}) {
  return <Button {...buttonProps} variant="tertiary" className={`fc-team-choice fc-team-choice--${side}`}>
    <span className="fc-team-choice__name">{name}</span><ChoiceCrest src={crest}/>
  </Button>;
}
